export function iconPencilWriting({ className }) {
  return (
    <svg
      width="120"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M13.3333 46.6666V40H36.6666V46.6666H13.3333ZM13.3333 33.3333V26.6666H50V33.3333H13.3333ZM13.3333 20V13.3333H50V20H13.3333ZM43.3333 66.6666V56.4166L61.75 38.0833C62.25 37.5833 62.8055 37.2222 63.4166 37C64.0278 36.7778 64.6389 36.6666 65.25 36.6666C65.9166 36.6666 66.5555 36.7916 67.1666 37.0416C67.7778 37.2916 68.3333 37.6666 68.8333 38.1666L71.9166 41.25C72.3611 41.75 72.7083 42.3055 72.9583 42.9166C73.2083 43.5278 73.3333 44.1389 73.3333 44.75C73.3333 45.3611 73.2222 45.9861 73 46.625C72.7778 47.2639 72.4166 47.8333 71.9166 48.3333L53.5833 66.6666H43.3333ZM48.3333 61.6666H51.5L61.5833 51.5L60.0833 49.9166L58.5 48.4166L48.3333 58.5V61.6666ZM60.0833 49.9166L58.5 48.4166L61.5833 51.5L60.0833 49.9166Z"
        fill="#2F80ED"
      />
    </svg>
  );
}
